import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import Panel from './LearninPlanBitePanel';
import Hotspot from './LearninPlanBiteHotSpot';
import MobileHotspot from './LearninPlanBiteHotSpotMobile';
import Badge from '../../objects/badges/Badge';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as enviromentHelper from '../../../helpers/environmentHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as learningPlanConstants from '../../../constants/learningPlanConstants';
import * as appConstants from '../../../constants/appConstants';
import * as navigationConstants from '../../../constants/navigationConstants';
import ExitBtn from '../../buttons/ExitButton';
import _ from 'lodash';

class LearningPlanMenu extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: props.lang,
            badges: props.badges,
            userDataBadges: props.userDataBadges,
            userData: props.userData,
            learningPlan: props.contentData.experience.learning_plan,
            lessonStatus: userDataHelper.getLessonStatus(this.props.userData.bites),
            learningPlanBites: Object.assign([],props.contentData.experience.learning_plan.bites),
            fontSize: props.fontSize,
            feedback_styles: props.contentData.experience.feedback_styles,
            height: undefined,
            updateHeight: false,
            bites: [],
            locale: appHelper.getLocalData(this.props.contentData.experience.learning_plan),
            filter: "required",
            hasOptionalBites: false,
            updateLearningPlan: false,
            assets: {
                background: {
                    src: "",
                    type: "",
                    type_id: ""
                },
                character: {
                    src: "",
                    pose: "",
                    position: ""
                }
            },
            show_label: appHelper.getLocaleString("show_label"),
            required_only_label: appHelper.getLocaleString("required_only_label"),
            all_label: appHelper.getLocaleString("all_label"),
            overall_label: appHelper.getLocaleString("overall_label"),
            score_label: appHelper.getLocaleString("score_label"),
            showExitBtn: appHelper.isDefined(this.props.contentData.experience) ? this.props.contentData.experience.exit_style !== navigationConstants.EXIT_STYLE_HIDDEN : false,
            env: enviromentHelper.getEnvironment(),
            showFilters: false,
            updateForced: false,
            hotspotSettings: {
                styles: {
                    top: 0,
                    height: appConstants.DESKTOP_MAX_HEIGHT,
                },
                maxHeight: appConstants.DESKTOP_MAX_HEIGHT,
                maxWidth: appConstants.DESKTOP_MAX_WIDTH,
            },
            avgScore: 0,
            completedBites: 0,
            showAchievedCount: false,
            showAchievedState: true,
            setDraggableBoundaries: false
        };
        this.menuContainer = React.createRef();
        this.menuHeader = React.createRef();
        this.badgesPanel = React.createRef();
        this.boundaryParams = React.createRef();
        this.dragMat = React.createRef();


        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.setFilterRequired = this.setFilterRequired.bind(this);
        this.setFilterAll = this.setFilterAll.bind(this);
        this.getFilterBtnClass = this.getFilterBtnClass.bind(this);
        this.setPersonalLearningPlanBites = this.setPersonalLearningPlanBites.bind(this);
        //this.jumpToBite = this.jumpToBite.bind(this);
        this.setHeight = _.debounce(this.setHeight.bind(this).bind(this), 100);
        this.getHeight = this.getHeight.bind(this);

        this.setDraggableBoundaries = this.setDraggableBoundaries.bind(this);

        this.componentWatcher = _.debounce(this.componentWatcher.bind(this), 100);

        this.getAverageScore = this.getAverageScore.bind(this);
        this.getUserProgressClass = this.getUserProgressClass.bind(this);
        this.getStyle = this.getStyle.bind(this);
    }


    componentDidMount() {
        window.addEventListener("resize", this.componentWatcher);
        this.props.actions.setNewLessonLocation(-1);
        this.setPersonalLearningPlanBites();
        this.getAssets();
        this.setDraggableBoundaries();
        this.getAverageScore();

    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                updateLearningPlan: true
            });
        }

        if (this.state.fontSize !== nextProps.fontSize) {
            this.setState({fontSize: nextProps.fontSize, updateHeight: true});
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.contentData.experience.learning_plan),
                show_label: appHelper.getLocaleString("show_label"),
                required_only_label: appHelper.getLocaleString("required_only_label"),
                all_label: appHelper.getLocaleString("all_label"),
                overall_score_label: appHelper.getLocaleString("overall_score_label"),
                overall_label: appHelper.getLocaleString("overall_label"),
                score_label: appHelper.getLocaleString("score_label"),

            });
        }
    }

    componentDidUpdate() {
        if (this.state.updateLearningPlan) {
            this.setPersonalLearningPlanBites();
        }

        if (this.state.updateHeight) {
            // this.setHeight();
        }

        if (this.state.setDraggableBoundaries) {
            this.setDraggableBoundaries();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.componentWatcher);
    }

    componentWatcher() {

        let env = enviromentHelper.getEnvironment();
        if (env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation) {
            this.setState({setDraggableBoundaries: true, env: Object.assign({}, env)});
        }

        this.setDraggableBoundaries();
    }

    getAverageScore() {
        let scores = [];
        let totalScore = 0;
        let avgScore = 0;
        let totalweight = 0;
        let completedBites = 0;
        _.forEach(this.state.userData.bites, function (bite) {

            let primaryKpi = appHelper.getArrayObjectByKey(bite.kpis, "is_primary", true);
            if (bite.required && appHelper.isDefined(primaryKpi)) {
                completedBites++;
                let score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
                if (isNaN(score) || bite.status !== objectConstants.STATUS_COMPLETE) {
                    score = 0;
                }

                let weightedScore = score * bite.weight;

                scores.push(weightedScore);
                totalScore += weightedScore;
                totalweight += bite.weight;
            }

        });

        if (totalweight > 0) {
            avgScore = Math.round(totalScore / totalweight);
        }

        this.setState({
            avgScore: avgScore,
            completedBites: completedBites
        });
    }

    setPersonalLearningPlanBites() {
        this.setState({updateLearningPlan: false});
        let bites = [];
        let hasOptionalBites = false;

        for (let i = 0; i < this.state.userData.bites.length; i++) {
            let bite = this.state.userData.bites[i];
            if (!bite.required && bite.visible) {
                hasOptionalBites = true;
            }

            bites = dataHelper.immutablePush(bites, bite);
        }
        //if(!appHelper.isDefined(localStorage.menu.reorder_optional_items) || (appHelper.isDefined(localStorage.menu.reorder_optional_items) && localStorage.menu.reorder_optional_items)) {
        bites.sort(function (a, b) {
            if (b.required < a.required) return -1;
            if (b.required > a.required) return 1;
            return 0;
        });
        //}


        let learningPlanBites = Object.assign([],this.state.learningPlanBites);

        learningPlanBites.sort(function (a, b) {
            if (b.display_order_id > a.display_order_id) return -1;
            if (b.display_order_id < a.display_order_id) return 1;
            return 0;
        });


        this.setState({learningPlanBites:Object.assign([], learningPlanBites), bites: Object.assign([], bites), hasOptionalBites: hasOptionalBites});


    }

    getAssets() {
        let backgroundAsset = Object.assign(this.state.assets.background);
        let screenCharacter = {};
        let characterAsset = Object.assign(this.state.assets.character);

        if (appHelper.isDefined(this.state.learningPlan.assets.background)) {
            backgroundAsset = appHelper.getBackgroundAsset(this.state.learningPlan.assets.background);
        }

        if (appHelper.isDefined(this.state.learningPlan.assets.character)) {
            screenCharacter = appHelper.getCharacterAsset(this.state.learningPlan.assets.character);
            characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.learningPlan.assets.character);
        }

        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: backgroundAsset,
                character: characterAsset,
            })
        });

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }


    setFilterRequired() {
        this.setState({filter: "required"});
    }

    setFilterAll() {
        this.setState({filter: "all"});
    }

    getFilterBtnClass(value) {
        return value === this.state.filter ? 'active' : '';
    }

    /*jumpToBite(){
        console.log('jump to bite');
        window.parent.postMessage({
            'func': 'setScreenId',
            'message' : {
                'screen_type': 'screen',
                'screen_id': 333
            }
        }, "*");
    }*/

    setHeight() {
        /*this.setState({updateHeight: false});
        let mainWrapper = document.getElementById('main-wrapper');
        let header = document.getElementById('learningPlanMenuHeader');

        if (appHelper.isDefined(header)) {
            let newHeight = (mainWrapper.offsetHeight - header.offsetHeight);
            this.setState({height: newHeight});
        }*/
    }

    getHeight() {
        /*let header = document.getElementById('learningPlanMenuHeader');
        if (header !== null && appHelper.isDefined(this.state.height)) {
            return {
                height: `${this.state.height}px`,
                minHeight: `${this.state.height}px`,
            };
        } else {
            return {};
        }*/
        return {};
    }


    setDraggableBoundaries() {
        if (!this.state.updateForced) {
            this.forceUpdate();
            this.setState({updateForced: true});
        }
        this.setState({setDraggableBoundaries: false});
        let hotspotContainer = this.boundaryParams.current;
        let menuHeader = this.menuHeader.current;
        let badgeHeight = 0;
        if ((this.state.learningPlan.badge_display === learningPlanConstants.LP_BADGE_DISPLAY_HEADER || this.state.learningPlan.badge_display === learningPlanConstants.LP_BADGE_DISPLAY_HEADER_AND_BITE) && this.state.badges.length > 0) {
            let badgePanel = this.badgesPanel.current;
            if (appHelper.isDefined(badgePanel) && badgePanel !== null) {
                badgeHeight = badgePanel.offsetHeight;
            }
        }
        if (appHelper.isDefined(hotspotContainer) && this.boundaryParams.current !== null) {

            let calculatedHeight = Math.round((hotspotContainer.offsetWidth / appConstants.DESKTOP_MAX_WIDTH) * (appConstants.DESKTOP_MAX_HEIGHT - (menuHeader.offsetHeight + badgeHeight)));
            //console.log(`appConstants.DESKTOP_MAX_HEIGHT`,appConstants.DESKTOP_MAX_HEIGHT,menuHeader.offsetHeight, badgeHeight);
            let hotspotSettings = Object.assign({}, this.state.hotspotSettings, {
                styles: {
                    top: menuHeader.offsetHeight + badgeHeight,
                    height: calculatedHeight,
                },
                maxHeight: appConstants.DESKTOP_MAX_HEIGHT - (menuHeader.offsetHeight + badgeHeight),//calculatedHeight
                width: hotspotContainer.offsetWidth,

            });

            if (this.state.env.window.size === "xs" || (this.state.env.window.size === "sm" && this.state.env.window.orientation === "portrait")) {
                hotspotSettings = Object.assign({}, this.state.hotspotSettings, {
                    styles: {
                        top: 0,
                        height: appConstants.DESKTOP_MAX_HEIGHT,
                    },
                    maxHeight: appConstants.DESKTOP_MAX_HEIGHT,
                    maxWidth: appConstants.DESKTOP_MAX_WIDTH,

                });
            }

            this.setState({hotspotSettings: Object.assign({}, hotspotSettings)});
        }

    }

    getUserProgressClass() {
        let className = ``;

        if (this.state.userData.status === objectConstants.STATUS_NOT_REQUIRED) {
            className += `${objectConstants.CLASS_NOT_REQUIRED} `;
        } else if (this.state.userData.status === objectConstants.STATUS_IN_PROGRESS) {
            className += `${objectConstants.CLASS_IN_PROGRESS} `;
        } else if (this.state.userData.status === objectConstants.STATUS_COMPLETE) {
            className += `${objectConstants.CLASS_COMPLETE} `;
        } else {
            className += `${objectConstants.CLASS_NOT_STARTED} `;
        }

        return className;
    }

    getStyle() {
        return this.state.env.window.size === "xs" || (this.state.env.window.size === "sm" && this.state.env.window.orientation == "portrait") ? "mobile" : "";
    }

    render() {
        let Dialog = this.props.dialogPopup.component;
        return (
            <div className="scenario-bite ">
                <div className="scenario-bite-content">
                    <div className="screen-wrapper full-screen">
                        <div className="menu-screen">
                            <div className="background-container" ref={this.boundaryParams}>
                                <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                            </div>
                            <div
                                className={`screen-container full-screen-tight ${this.state.learningPlan.display_type}`}>
                                <div className="learning-plan-menu-container" ref={this.menuContainer}>
                                    <div className={`learning-plan-menu-header ${this.state.learningPlan.header_type}`}
                                         id="learningPlanMenuHeader" ref={this.menuHeader}>

                                        <div className={`label-panel ${this.state.showExitBtn ? "include-nav" : ""}`}>

                                            {
                                                appHelper.isDefined(this.state.locale.title) && this.state.locale.title.length > 0
                                                    ?
                                                    <div className="flex-1">
                                                        <h3 className="text-center">{this.state.locale.title}</h3>
                                                    </div>
                                                    :
                                                    null
                                            }

                                        </div>


                                        <div className="filter-panel">
                                            {
                                                appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                                    ?
                                                    <div className="instruction-text"
                                                         dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                                    :
                                                    null
                                            }

                                            {
                                                this.state.showFilters
                                                    ?
                                                    <div className="inline-block">
                                                        <div className="inline-block">
                                                            <div
                                                                className="text-right">{this.state.show_label}: &nbsp; &nbsp;</div>
                                                        </div>
                                                        <div className="btn-group text-right">
                                                            <button type="button"
                                                                    className={`btn ${this.getFilterBtnClass("required")}`}
                                                                    onClick={this.setFilterRequired}>{this.state.required_only_label}
                                                            </button>
                                                            <button type="button"
                                                                    className={`btn ${this.getFilterBtnClass("all")}`}
                                                                    onClick={this.setFilterAll}>{this.state.all_label}
                                                            </button>


                                                        </div>
                                                    </div>
                                                    : null
                                            }

                                        </div>
                                        {this.state.assets.character.src.length > 0
                                            ?
                                            <div className="character-image">
                                                <div className="character-image-wrapper">
                                                    <img src={this.getImagePath(this.state.assets.character.src)}
                                                         alt=""/>
                                                </div>
                                            </div> :
                                            null
                                        }
                                        <div className="learning-plan-nav">
                                            {this.state.learningPlan.overall_score_type !== learningPlanConstants.LP_OVERALL_SCORE_TYPE_NONE && this.state.learningPlan.overall_score_type !== learningPlanConstants.LP_OVERALL_SCORE_TYPE_HIDDEN
                                                ?
                                                <div className="nav-item">
                                                    <div className="overall-score-panel">
                                                        <div
                                                            className={`score-dashboard ${this.getUserProgressClass()}`}>
                                                            <div
                                                                className="dashboard-col score-label">{this.state.overall_label}&nbsp;
                                                                <br/><strong>{this.state.score_label}</strong>
                                                            </div>
                                                            {/*Overall<br/><strong>Score</strong></div>*/}
                                                            <div
                                                                className="dashboard-col score-value">{this.state.avgScore}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                null
                                            }

                                            {
                                                this.state.showExitBtn
                                                    ?
                                                    <div className="nav-item">
                                                        <ExitBtn/>
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                    </div>
                                    {(this.state.learningPlan.badge_display === learningPlanConstants.LP_BADGE_DISPLAY_HEADER || this.state.learningPlan.badge_display === learningPlanConstants.LP_BADGE_DISPLAY_HEADER_AND_BITE) && this.state.badges.length > 0
                                        ?
                                        <div className="experience-badges-panel" ref={this.badgesPanel}>
                                            <ul className="badge-list">
                                                {this.state.badges.map((badge, index) =>
                                                    <li key={badge.badge_id} className="badge-item">
                                                        <Badge badge={badge}
                                                               userBadge={appHelper.getArrayObjectByKey(this.state.userDataBadges, "badge_id", badge.badge_id)}
                                                               showAchievedCount={this.state.showAchievedCount}
                                                               showAchievedState={this.state.showAchievedState}/>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                        :
                                        null
                                    }

                                    {this.state.learningPlan.display_type === learningPlanConstants.LP_DISPLAY_TYPE_LIST && this.state.bites.length > 0
                                        ?
                                        <div className="personalised-menu-body" style={this.getHeight()}>
                                            <ul className="menu-panel-list">
                                                {this.state.learningPlanBites.map(menuBiteData =>
                                                    <li className="panel-item" key={menuBiteData.bite_id}>
                                                        <Panel menuData={menuBiteData}
                                                               bite={appHelper.getBiteById(menuBiteData.bite_id)}
                                                               required={appHelper.getArrayObjectByKey(this.state.bites, "bite_id", menuBiteData.bite_id).required}
                                                               learningPlan={this.state.learningPlan}
                                                               filter={this.state.filter}
                                                               learningPlanBites={this.state.learningPlanBites}

                                                        />
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                        :
                                        null
                                    }

                                    {this.state.learningPlan.display_type === learningPlanConstants.LP_DISPLAY_TYPE_GAMEBOARD && this.state.bites.length > 0
                                        ?

                                        <div className={`learning-plan-drag-mat ${this.getStyle()}`} ref={this.dragMat}
                                             style={this.state.env.window.size !== "xs" && (this.state.env.window.size !== "sm" && this.state.env.window.orientation !== "portrait") ? this.state.hotspotSettings.styles : {}}
                                             id="dragBoundaries">
                                            {this.state.learningPlanBites.map(menuBiteData =>
                                                this.state.env.window.size !== "xs" && (this.state.env.window.size !== "sm" && this.state.env.window.orientation !== "portrait")
                                                    ?
                                                    <Hotspot
                                                        key={menuBiteData.bite_id}
                                                        menuData={menuBiteData}
                                                        bite={appHelper.getBiteById(menuBiteData.bite_id)}
                                                        required={appHelper.getArrayObjectByKey(this.state.bites, "bite_id", menuBiteData.bite_id).required}
                                                        filter={this.state.filter}
                                                        learningPlan={this.state.learningPlan}
                                                        learningPlanBites={this.state.learningPlanBites}
                                                        draggableBoundaries={this.dragMat.current}
                                                        hotspotSettings={this.state.hotspotSettings}
                                                        menuContainer={this.menuContainer.current}
                                                        badgesPanel={this.badgesPanel.current}
                                                    />
                                                    :
                                                    <MobileHotspot
                                                        key={menuBiteData.bite_id}
                                                        menuData={menuBiteData}
                                                        bite={appHelper.getBiteById(menuBiteData.bite_id)}
                                                        required={appHelper.getArrayObjectByKey(this.state.bites, "bite_id", menuBiteData.bite_id).required}
                                                        filter={this.state.filter}
                                                        learningPlan={this.state.learningPlan}
                                                        learningPlanBites={this.state.learningPlanBites}
                                                        hotspotSettings={this.state.hotspotSettings}

                                                    />
                                            )}
                                        </div>
                                        :
                                        null
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.dialogPopup.render
                    ? <Dialog/>
                    : null
                }

            </div>

        );
    }
}

LearningPlanMenu.propTypes = {
    badges: PropTypes.array.isRequired,
    userDataBadges: PropTypes.array.isRequired,
    contentData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    fontSize: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    dialogPopup: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

LearningPlanMenu.contextTypes = {
    router: PropTypes.object,

};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        userData: state.userData,
        badges: state.contentData.experience.badges,
        userDataBadges: state.userData.badges,
        trackingData: state.trackingData,
        fontSize: state.fontSize,
        dialogPopup: state.dialogPopup,

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LearningPlanMenu);



/** WEBPACK FOOTER **
 ** ./src/components/menus/learningPlan/LearningPlanMenu.js
 **/